export default "__VITE_ASSET__c54d5d94__"